export default __webpack_public_path__ + "static/shiba_inu-ab75a889709b539aa7da5f7cbbc50441.png";